var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuraTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "grad",
    cx: 64,
    cy: 64,
    r: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--color-accent, #37E5FF)",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--color-accent, #37E5FF)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("style", null, "\n      :root { --p: var(--color-primary,#7C4DFF); --a: var(--color-accent,#37E5FF); }\n      .ring  { stroke: var(--a); stroke-width: 6; fill: none; stroke-dasharray: 8 12; animation: spin 8s linear infinite; }\n      .ring2 { stroke: var(--p); stroke-width: 2; fill: none; stroke-dasharray: 2 6; opacity:.7; animation: spin 14s linear reverse infinite; }\n      .pulse { fill: url(#grad); filter:url(#blur); transform-origin:64px 64px; animation: pulse 2s ease-in-out infinite; }\n      @keyframes spin { to { transform: rotate(360deg); } }\n      @keyframes pulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.08); } }\n      @media (prefers-reduced-motion: reduce) { .ring,.ring2,.pulse { animation: none; } }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "pulse",
    cx: 64,
    cy: 64,
    r: 62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "ring",
    cx: 64,
    cy: 64,
    r: 50
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "ring2",
    cx: 64,
    cy: 64,
    r: 38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuraTimer);
export default __webpack_public_path__ + "static/media/aura-timer.1530138ece49021a4e0f7b87cfbea8f2.svg";
export { ForwardRef as ReactComponent };